import React from 'react';
import { CTAButton } from './CTAButton';
import { ArrowRightIcon } from 'lucide-react';
export function Header() {
  return <header className="mb-1" data-id="element-94">
      <div className="bg-gray-200 py-1 mb-4 text-center border-b border-gray-50" data-id="element-95">
        <p className="text-sm tracking-wide text-gray-800" data-id="element-96">
          Advertorial
        </p>
      </div>
      <h1 className="text-3xl md:text-4xl text-center font-bold mb-4 text-black-900" data-id="element-97">
        How This Australian Cat Mum Effortlessly Eliminated Cat Dander from Her Home in Just 28 Minutes
      </h1>
      <div className="text-m mb-8 text-center" data-id="element-98">September 2rd, 2025</div>
      <div className="relative mb-8" data-id="element-99">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/k3Vg355riRQ4JVYvaSTLTv/ChatGPT_Image_Aug_28%2C_2025%2C_02_23_49_PM.png" alt="Black and white cat walking on a blue rug with baking soda scattered around as a home remedy for dander" className="w-full rounded-lg shadow-lg" data-id="element-100" />
      </div>
    </header>;
}